import React from 'react';
import { Users, Wallet, ScanLine, TrendingUp } from 'lucide-react';

const BARS = [40, 65, 50, 80, 60, 95, 70];
const ACTIVITY = [
  { icon: ScanLine, text: 'تسجيل حضور — فئة تحت 14' },
  { icon: Users, text: 'إضافة لاعب جديد للفريق الأول' },
  { icon: Wallet, text: 'دفعة اشتراك شهري مستلمة' },
];

export const DashboardMockup = () => {
  return (
    <div className="relative mx-auto w-full max-w-md" data-testid="landing-hero-dashboard-mockup">
      <div className="absolute -inset-6 -z-10 rounded-[2rem] bg-teal-500/10 blur-2xl" />
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-[#0A192F]/90 shadow-2xl shadow-black/50 backdrop-blur-xl">
        <div className="flex items-center gap-2 border-b border-white/5 bg-white/[0.02] px-4 py-3">
          <span className="h-2.5 w-2.5 rounded-full bg-red-400/70" />
          <span className="h-2.5 w-2.5 rounded-full bg-amber-400/70" />
          <span className="h-2.5 w-2.5 rounded-full bg-teal-400/70" />
          <span className="font-display ms-2 text-xs font-semibold text-slate-400">لوحة تحكم تسيار</span>
        </div>

        <div className="p-5">
          <div className="grid grid-cols-3 gap-3">
            <div className="rounded-xl border border-white/5 bg-white/[0.03] p-3">
              <Users className="h-4 w-4 text-teal-400" />
              <div className="mt-2 font-display text-lg font-black text-white">128</div>
              <div className="text-[11px] text-slate-400">لاعب نشط</div>
            </div>
            <div className="rounded-xl border border-white/5 bg-white/[0.03] p-3">
              <ScanLine className="h-4 w-4 text-teal-400" />
              <div className="mt-2 font-display text-lg font-black text-white">%94</div>
              <div className="text-[11px] text-slate-400">نسبة الحضور</div>
            </div>
            <div className="rounded-xl border border-orange-400/20 bg-orange-400/[0.06] p-3">
              <TrendingUp className="h-4 w-4 text-orange-400" />
              <div className="mt-2 font-display text-lg font-black text-white">%18+</div>
              <div className="text-[11px] text-slate-400">نمو الاشتراكات</div>
            </div>
          </div>

          <div className="mt-4 rounded-xl border border-white/5 bg-white/[0.03] p-3">
            <div className="mb-2 text-[11px] font-semibold text-slate-400">الحضور الأسبوعي</div>
            <div className="flex h-16 items-end gap-1.5">
              {BARS.map((h, i) => (
                <div key={i} className="flex-1 rounded-t-sm bg-gradient-to-t from-teal-600 to-teal-400" style={{ height: `${h}%` }} />
              ))}
            </div>
          </div>

          <div className="mt-4 space-y-2">
            <div className="text-[11px] font-semibold text-slate-400">آخر الأنشطة</div>
            {ACTIVITY.map((a, i) => (
              <div key={i} className="flex items-center gap-2 rounded-lg border border-white/5 bg-white/[0.02] px-3 py-2">
                <a.icon className="h-3.5 w-3.5 flex-shrink-0 text-teal-400" />
                <span className="text-[11px] text-slate-300">{a.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardMockup;
